<template>
	<span id="programBranding">
		<span class="programLogo floatingLogo">
			<img src="../../assets/programLogo.png" width="134px" height="115px"/>
		</span>

		<span class="euLogo floatingLogo">
			<img src="../../assets/euSmall.png" width="134px" height="140px"/>
		</span>
		<!--
		<span class="projectLink floatingLogo">
			<router-link to="/programInfo"  style="text-decoration:none;color:black">Project Info
			<v-icon style="vertical-align:middle" class="black--text">arrow_right</v-icon></router-link>
		</span>
		-->
	</span>
</template>

<style scoped>

@media (max-width: 1380px) {
	#programBranding {
		display:none !important;
	}
}

.floatingLogo {
	position: absolute;
    right: 0px;
    z-index: 20;
    background: white;
    padding: 3px;
    --border: 1px solid #e8e8e8;
    -webkit-box-shadow: rgba(128, 128, 128, 0.56) -12px 6px 18px -21px;
    box-shadow: rgba(128, 128, 128, 0.56) -12px 6px 18px -21px;
}

.programLogo {
	top: 380px;
}

.euLogo {
	top: 507px;
}

.projectLink {
	top: 810px;
	width:140px;
	text-align:center;
	box-shadow: rgba(128, 128, 128, 0.56) -12px 6px 18px -13px;
}

.projectLink:hover {
	background:#f2f0ed;
}

</style>

<script>
export default {
  name: 'lingo_program_branding',
  data() {
    return {

    };
  }
}
</script>
